import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';

export interface AppointmentData {
  date: Date;
  startTime: string;
  endTime: string;
}

@Component({
  selector: 'app-ask-for-appointment',
  templateUrl: './ask-for-appointment.component.html',
  styleUrls: [
    './ask-for-appointment.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class AskForAppointmentComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter<AppointmentData>();
  public formGroup: FormGroup;

  public customTimePickerTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--white)',
    },
    dial: {
      dialBackgroundColor: 'var(--primary)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--box-shadow-grey)',
      clockHandColor: 'var(--primary)',
      clockFaceTimeInactiveColor: 'var(--white)'
    }
  };

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _snackbar: SnackbarService
  ) {}

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      date: [null, Validators.required],
      startTime: ['09:00', Validators.required],
      endTime: ['09:30', Validators.required]
    });
  }

  public timeChanged(event: string, control: string): void {
    this.formGroup.get(control).patchValue(event);
  }

  public validAppointment(): void {
    if (this.formGroup.valid) {
      const date = moment(this.formGroup.get('date').value).toDate();
      const startTime = this.formGroup.get('startTime').value;
      const endTime = this.formGroup.get('endTime').value;
      const [startHour, startMinute] = startTime.split(':').map(Number);
      const [endHour, endMinute] = endTime.split(':').map(Number);
      
      const startMinutes = startHour * 60 + startMinute;
      const endMinutes = endHour * 60 + endMinute;

      if (endMinutes <= startMinutes) {
        this._snackbar.openSnackBarError('L\'heure de fin doit être après l\'heure de début');
        return;
      }

      const appointmentData: AppointmentData = {
        date,
        startTime,
        endTime
      };

      this.closeModal(appointmentData);
    }
  }

  public closeModal(appointmentData?: AppointmentData): void {
    this.closeEmitter.emit(appointmentData);
  }

}
